export const topIconsList = [
	{
		icon: 'https://i.imgur.com/jFkgXhu.png',
		text: 'Volume',
		url: null,
	}, {
		icon: 'https://i.imgur.com/Fb1IAgl.png',
		text: 'Android',
		url: 'https://play.google.com/store/apps/details?id=com.csm.hptcp.hptcpmobileapp',
	}, {
		icon: 'https://i.imgur.com/u3rR5CI.png',
		text: 'Apple',
		url: 'https://itunes.apple.com/us/app/him-tcp/id1161638555?ls=1&mt=8',
	}, {
		icon: 'https://i.imgur.com/JDHzKDv.png',
		text: 'Microsoft',
		url: 'https://www.microsoft.com/en-in/store/p/him-tcp/9nblggh406mz',
	}, 
]

export const bannerImgUrls = [
	// 'https://i.imgur.com/0vt1uj3.jpeg', // hiding it till achar sanhita
	'https://i.imgur.com/lrTWHNw.png',
]

export const bannerCmStripData = [
	{
		photo: "https://www.awasbandhu.in/wp-content/uploads/2023/01/cmyogi.jpg",
		name: "Yogi Adityanath",
		designation: "Hon'ble Chief Minister",
	}, 
	// {
	// 	photo: "https://i.imgur.com/Qx9H09H.png",
	// 	name: "Sh. Mukesh Agnihotri",
	// 	designation: "Hon'ble Deputy Chief Minister",
	// }, 
    // {
	// 	photo: "https://i.imgur.com/VKmMLLA.png",
	// 	name: "Sh. Rajesh Dharmani",
	// 	designation: "Hon'ble TCP Minister",
	// },
    {
		photo: "https://www.awasbandhu.in/wp-content/uploads/2023/01/principal-sec.jpg",
		name: "Dr. Nitin Ramesh Gokarn",
		designation: "Addl. Chief Secretary, Housing and Urban Planning",
	}, 
	{
		photo: "https://www.awasbandhu.in/wp-content/uploads/2024/03/principal-sec-02.png",
		name: "Dr. Balkar Singh",
		designation: "Executive Director, Awas Bandhu",
	},
]

export const getServicesData = (toggleModal) => ([
	{
		icon: 'https://i.imgur.com/72lqHju.png',
		label: 'Online Services',
		action: '/digit-ui/citizen/profile',
        gradientClass: ''
	}, 
    {
		icon: 'https://i.imgur.com/RLDNCUS.png',
		label: 'Officer Login',
		action: '/digit-ui/employee',
	},
    {
		icon: 'https://i.imgur.com/9piU18h.png',
		label: 'Fee Calculator',
		action: '/digit-ui/citizen/feeCalculator',
	}, {
		icon: 'https://i.imgur.com/mfeY0Ib.png',
		label: 'Check Application Status',
		action: toggleModal,
	},
])

export const homeUrl = '/digit-ui/citizen'
export const navData = [
	{
		label: 'Home',
		url: homeUrl,
	}, {
		label: 'About Us',
		url: `${homeUrl}/objectives`,
	}, 
    {
		label: 'Contact Us',
		url: `${homeUrl}/contact-us`,
	},
    {
		label: 'Planning Regulations',
		url: `${homeUrl}/appendix-1`,
	}, 
    {
		label: 'Development Plan',
		url: `${homeUrl}/development-plan`,
	}, 
    {
		label: 'Notification / Order',
		url: `${homeUrl}/notifications-under-tcp-act`,
	}, {
		label: 'Acts & Rules',
		url: null,
		subMenu: [
			{
				label: 'Delegation of Power',
				url: `${homeUrl}/delegation-of-powers`,
			}, 
		],
	}, {
		label: 'Media',
		url: `${homeUrl}/photo-gallery`,
	}, 
]

export const checklistData = [
	{
		label: 'Form of application for permission of sub-division / development of land',
		url: '#',
		onClick: () => null
	}, {
		label: 'Inspection Procedure and Checklist of obtaining Final NOC',
		url: '#',
		onClick: () => null
	}, {
		label: 'Inspection Procedure and checklist of obtaining Construction Permit',
		url: '#',
		onClick: () => null
	}, {
		label: 'Form Application for compostion of offences under section 39-C read with sub-section (3) of section',
		url: '#',
		onClick: () => null
	}, {
		label: 'Procedure and Guidelines for Obtaining Planning Permission on Form 12',
		url: '#',
		onClick: () => null
	}, {
		label: 'Form of application for permission of Development of Land / Construction of Building',
		url: '#',
		onClick: () => null
	}, {
		label: 'Inspection Procedure and checklist of obtaining Construction Permit',
		url: '#',
		onClick: () => null
	}, {
		label: 'Procedure and Guidelines for Obtaining Planning Permission on Form 12',
		url: '#',
		onClick: () => null
	}, {
		label: 'Inspection Procedure and checklist of obtaining Construction Permit',
		url: '#',
		onClick: () => null
	}, {
		label: 'Procedure, Checklist for Obtaining NOC After...',
		url: '#',
		onClick: () => null
	}, {
		label: 'Inspection Procedure & Checklist for ...',
		url: '#',
		onClick: () => null
	},
]

export const feedbackFormFields = [
	{
		name: 'name',
		label: 'Name',
		placeholder: 'Name',
	},
	{
		name: 'mobileNo',
		label: 'Mobile No.',
		placeholder: 'Mobile No.',
	},
	{
		name: 'email',
		label: 'E-mail',
		placeholder: 'E-mail',
	},
	{
		name: 'subject',
		label: 'Subject',
		placeholder: 'Subject',
	},
	{
		name: 'message',
		label: 'Message',
		placeholder: 'Enter Your Message',
	},
]

export const feedbackFormDefaults = {
	formType: "feedback",
	name: '',
	mobileNo: '',
	email: '',
	subject: '',
	message: '',
	// captcha: '',
}

